<template>
    <div class="gc-bglayer-button"
         v-on:click="$emit('toggleExpanded')"
         v-bind:class="[{ 'gc-map-control-button': isExpanded, 'gc-bglayer': !isExpanded}, (visibleLayer ? visibleLayer.previewClassName : '') ]"
         v-bind:style="[visibleLayer && visibleLayer.previewImage ? { 'background-image': 'url(' + visibleLayer.previewImage + ')' } : {}]"
         v-bind:title="isExpanded ? 'Hintergrundkartenauswahl ausblenden' : 'Hintergrundkartenauswahl anzeigen'"
    >
        <span v-show="isExpanded" class="gc-icon glyphicon glyphicon-chevron-right"></span>
        <span v-show="!isExpanded">Hintergrund</span>
    </div>
</template>

<script>
    export default {
        name: "LayerListButton",
        props: {
            layers: {
                type: Array,
                required: true
            },
            isExpanded: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            visibleLayer: function () {
                for (let i = 0, ii = this.layers.length; i < ii; i++)
                {
                    if (this.layers[i].isVisible)
                        return this.layers[i];
                }
                return undefined;
            }
        },
        mounted: function() {
            this.$nextTick(function () {
                gc.gis.iface.ui.tooltip(this.$el, {
                    placement: 'auto top'
                });
            })
        }
    }
</script>